import React, { useState } from 'react';
import { AuthLayout, Button, TextField } from '@talbenmoshe/trip-os-design-system';
import { SignInActivity, SignInFailure, useSignIn, useSignInFacade } from '@talbenmoshe/trip-os-react-model';
import { useMessages } from '../i18n/messagesContext.js';
import { GoogleSignInSection } from './GoogleSignInSection.js';
import { SignedOutNotice } from './SignedOutNotice.js';
import { SignInNoticeBanner } from './SignInNoticeBanner.js';

/** Step 1 of sign-in (frames C1–C3): the email address, "Send me a code", then "or" and "Continue with Google". */
export function EmailStep() {
  const messages = useMessages();
  const signIn = useSignIn();
  const facade = useSignInFacade();
  const [emailDraft, setEmailDraft] = useState(signIn.email);
  const isSending = signIn.activity === SignInActivity.SENDING_CODE;
  // While a code sends the button shows its own loading state (and keeps focus); only Google's check disables it.
  const isCheckingGoogleAccount = signIn.activity === SignInActivity.SIGNING_IN_WITH_GOOGLE;
  const emailError = signIn.failure === SignInFailure.INVALID_EMAIL ? messages.SIGN_IN_INVALID_EMAIL() : undefined;

  function handleSubmit(): void {
    void facade.requestSignInCode(emailDraft);
  }

  return (
    <AuthLayout
      wordmarkLabel={messages.SIGN_IN_WORDMARK_LABEL()}
      title={messages.SIGN_IN_EMAIL_TITLE()}
      description={messages.SIGN_IN_EMAIL_DESCRIPTION()}
      leadNotice={<SignedOutNotice notice={signIn.notice} />}
      notice={<SignInNoticeBanner failure={signIn.failure} notice={signIn.notice} />}
      footnote={messages.SIGN_IN_NEW_ACCOUNT_NOTE()}
      onSubmit={handleSubmit}
    >
      <TextField
        label={messages.SIGN_IN_EMAIL_LABEL()}
        value={emailDraft}
        onChange={setEmailDraft}
        placeholder={messages.SIGN_IN_EMAIL_PLACEHOLDER()}
        error={emailError}
        errorRevision={signIn.failureRevision}
        type="email"
        autoComplete="email"
        required
        disabled={signIn.isBusy}
        autoFocus
      />
      <Button
        label={messages.SIGN_IN_SEND_CODE()}
        type="submit"
        fullWidth
        loading={isSending}
        loadingLabel={messages.SIGN_IN_SENDING_CODE()}
        disabled={isCheckingGoogleAccount}
      />
      <GoogleSignInSection />
    </AuthLayout>
  );
}
